import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnSwapStep_14 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_14 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_14) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_13);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_15);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="buy"
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_14;
